/**
 * 홈 히어로 배너의 노출 예약 윈도우 판정 (ID45 / BE V82).
 *
 * 구현은 `features/cms/lib/displaySchedule` 에 있다 — 홈 팝업이 같은 BE 규칙(start ≤ now < end,
 * null = 제약 없음)을 쓰게 되면서 한 곳으로 모았다. 여기서는 배너 쪽 이름만 유지한다.
 */
import {
  displayScheduleState,
  isDisplayLive,
  isWithinDisplaySchedule,
  type DisplayScheduleState,
  type DisplayScheduleWindow,
} from '../../lib/displaySchedule';

export type BannerScheduleWindow = DisplayScheduleWindow;
export type BannerScheduleState = DisplayScheduleState;

export const bannerScheduleState = displayScheduleState;
export const isWithinBannerSchedule = isWithinDisplaySchedule;
export const isBannerLive = isDisplayLive;
